import { ref } from "@nuxtjs/composition-api";
const predefinedCrumbs = {
  main: { text: "home_page", link: "/" },
  categories: { text: "categories" },
  catalog: { text: "catalog", link: "/catalog" },
  search: { text: "searching_results" }
};
function useBreadcrumbs() {
  const breadcrumbs = ref([predefinedCrumbs.main]);
  const prepareCrumb = (item) => typeof item === "string" ? predefinedCrumbs[item] ?? { text: item } : item;
  const applyCrumbs = (items, rewrite = false) => {
    const newItems = items.map(prepareCrumb);
    if (rewrite)
      breadcrumbs.value = newItems;
    else
      breadcrumbs.value.push(...newItems);
  };
  const addCrumbs = (...items) => applyCrumbs(items);
  const setCrumbs = (...items) => applyCrumbs(items, true);
  return {
    breadcrumbs,
    addCrumbs,
    setCrumbs
  };
}
var useBreadcrumbs_default = useBreadcrumbs;
export {
  useBreadcrumbs_default as default
};
